const { createAction } = require("../../helpers");
const {
  ALL_ORDERS_LIST,
  ALL_ORDERS_LIST_SUCCESS,
  ALL_ORDERS_LIST_ERROR,
  ALL_ORDERS_LIST_RESET,

  TOPAY_ORDERS_LIST,
  TOPAY_ORDERS_LIST_SUCCESS,
  TOPAY_ORDERS_LIST_ERROR,
  TOPAY_ORDERS_LIST_RESET,

  TOPACK_ORDERS_LIST,
  TOPACK_ORDERS_LIST_SUCCESS,
  TOPACK_ORDERS_LIST_ERROR,
  TOPACK_ORDERS_LIST_RESET,

  TOSHIP_ORDERS_LIST,
  TOSHIP_ORDERS_LIST_SUCCESS,
  TOSHIP_ORDERS_LIST_ERROR,
  TOSHIP_ORDERS_LIST_RESET,

  TORECEIVE_ORDERS_LIST,
  TORECEIVE_ORDERS_LIST_SUCCESS,
  TORECEIVE_ORDERS_LIST_ERROR,
  TORECEIVE_ORDERS_LIST_RESET,

  TOCOMPLETE_ORDERS_LIST,
  TOCOMPLETE_ORDERS_LIST_SUCCESS,
  TOCOMPLETE_ORDERS_LIST_ERROR,
  TOCOMPLETE_ORDERS_LIST_RESET,

  RETURN_ORDERS_LIST,
  RETURN_ORDERS_LIST_SUCCESS,
  RETURN_ORDERS_LIST_ERROR,
  RETURN_ORDERS_LIST_RESET,

  GET_ORDER_DETAILS,
  GET_ORDER_DETAILS_SUCCESS,
  GET_ORDER_DETAILS_RESET,
  GET_ORDER_DETAILS_ERROR,

  CANCEL_ORDERS,
  CANCEL_ORDERS_SUCCESS,
  CANCEL_ORDERS_RESET,
  CANCEL_ORDERS_ERROR,

  CANCEL_THE_ORDER,
  CANCEL_THE_ORDER_SUCCESS,
  CANCEL_THE_ORDER_ERROR,
  CANCEL_THE_ORDER_RESET,

  RECEIVED_ORDERS,
  RECEIVED_ORDERS_SUCCESS,
  RECEIVED_ORDERS_ERROR,
  RECEIVED_ORDERS_RESET,

  TO_ACCEPT_ORDERS_LIST,
  TO_ACCEPT_ORDERS_LIST_SUCCESS,
  TO_ACCEPT_ORDERS_LIST_ERROR,
  TO_ACCEPT_ORDERS_LIST_RESET,

  TO_REDEEM_ORDERS_LIST,
  TO_REDEEM_ORDERS_LIST_SUCCESS,
  TO_REDEEM_ORDERS_LIST_ERROR,
  TO_REDEEM_ORDERS_LIST_RESET,
} = require("./constants");

const allOrdersLists = ({ status, page, pageSize, isBusiness }) =>
  createAction(ALL_ORDERS_LIST, { status, page, pageSize, isBusiness });

const allOrdersListsSuccess = (data) =>
  createAction(ALL_ORDERS_LIST_SUCCESS, { data });

const allOrdersListsError = (error) =>
  createAction(ALL_ORDERS_LIST_ERROR, { error });

const allOrdersListsReset = () => createAction(ALL_ORDERS_LIST_RESET);

const toPayOrdersLists = ({ status, page, pageSize, isBusiness }) =>
  createAction(TOPAY_ORDERS_LIST, { status, page, pageSize, isBusiness });

const toPayOrdersListsSuccess = (data) =>
  createAction(TOPAY_ORDERS_LIST_SUCCESS, { data });

const toPayOrdersListsError = (error) =>
  createAction(TOPAY_ORDERS_LIST_ERROR, { error });

const toPayOrdersListsReset = () => createAction(TOPAY_ORDERS_LIST_RESET);

const toPackOrdersLists = ({ status, page, pageSize, isBusiness }) =>
  createAction(TOPACK_ORDERS_LIST, { status, page, pageSize, isBusiness });

const toPackOrdersListsSuccess = (data) =>
  createAction(TOPACK_ORDERS_LIST_SUCCESS, { data });

const toPackOrdersListsError = (error) =>
  createAction(TOPACK_ORDERS_LIST_ERROR, { error });

const toPackOrdersListsReset = () => createAction(TOPACK_ORDERS_LIST_RESET);

const toShipOrdersLists = ({ status, page, pageSize, isBusiness }) =>
  createAction(TOSHIP_ORDERS_LIST, { status, page, pageSize, isBusiness });

const toShipOrdersListsSuccess = (data) =>
  createAction(TOSHIP_ORDERS_LIST_SUCCESS, { data });

const toShipOrdersListsError = (error) =>
  createAction(TOSHIP_ORDERS_LIST_ERROR, { error });

const toShipOrdersListsReset = () => createAction(TOSHIP_ORDERS_LIST_RESET);

const toRecieveOrdersLists = ({ status, page, pageSize, isBusiness }) =>
  createAction(TORECEIVE_ORDERS_LIST, { status, page, pageSize, isBusiness });

const toRecieveOrdersListsSuccess = (data) =>
  createAction(TORECEIVE_ORDERS_LIST_SUCCESS, { data });

const toRecieveOrdersListsError = (error) =>
  createAction(TORECEIVE_ORDERS_LIST_ERROR, { error });

const toRecieveOrdersListsReset = () =>
  createAction(TORECEIVE_ORDERS_LIST_RESET);

const toCompleteOrdersLists = ({ status, page, pageSize, isBusiness }) =>
  createAction(TOCOMPLETE_ORDERS_LIST, { status, page, pageSize, isBusiness });

const toCompleteOrdersListsSuccess = (data) =>
  createAction(TOCOMPLETE_ORDERS_LIST_SUCCESS, { data });

const toCompleteOrdersListsError = (error) =>
  createAction(TOCOMPLETE_ORDERS_LIST_ERROR, { error });

const toCompleteOrdersListsReset = () =>
  createAction(TOCOMPLETE_ORDERS_LIST_RESET);

const returnOrdersLists = ({ status, page, pageSize, isBusiness }) =>
  createAction(RETURN_ORDERS_LIST, { status, page, pageSize, isBusiness });

const returnOrdersListsSuccess = (data) =>
  createAction(RETURN_ORDERS_LIST_SUCCESS, { data });

const returnOrdersListsError = (error) =>
  createAction(RETURN_ORDERS_LIST_ERROR, { error });

const returnOrdersListsReset = () => createAction(RETURN_ORDERS_LIST_RESET);

const cancel = ({ status, page, pageSize, isBusiness }) =>
  createAction(CANCEL_ORDERS, { status, page, pageSize, isBusiness });

const cancelSuccess = (data) => createAction(CANCEL_ORDERS_SUCCESS, { data });

const cancelError = (error) => createAction(CANCEL_ORDERS_ERROR, { error });

const cancelReset = () => createAction(CANCEL_ORDERS_RESET);

const orderDetails = (orderId) => createAction(GET_ORDER_DETAILS, { orderId });

const orderDetailsSuccess = (data) =>
  createAction(GET_ORDER_DETAILS_SUCCESS, { data });

const orderDetailsError = (error) =>
  createAction(GET_ORDER_DETAILS_ERROR, { error });

const orderDetailsReset = () => createAction(GET_ORDER_DETAILS_RESET);

const cancelledOrders = (orderId) =>
  createAction(CANCEL_THE_ORDER, { orderId });

const cancelledOrdersSuccess = (data) =>
  createAction(CANCEL_THE_ORDER_SUCCESS, { data });

const cancelledOrdersError = (error) =>
  createAction(CANCEL_THE_ORDER_ERROR, { error });

const cancelledOrdersReset = () => createAction(CANCEL_THE_ORDER_RESET);

const recievedOrders = (orderId) => createAction(RECEIVED_ORDERS, { orderId });

const recievedOrdersSuccess = (data) =>
  createAction(RECEIVED_ORDERS_SUCCESS, { data });

const recievedOrdersError = (error) =>
  createAction(RECEIVED_ORDERS_ERROR, { error });

const recievedOrdersReset = () => createAction(RECEIVED_ORDERS_RESET);

const toAcceptOrdersLists = ({ status, page, pageSize, isBusiness }) =>
  createAction(TO_ACCEPT_ORDERS_LIST, { status, page, pageSize, isBusiness });

const toAcceptOrdersListsSuccess = (data) =>
  createAction(TO_ACCEPT_ORDERS_LIST_SUCCESS, { data });

const toAcceptOrdersListsError = (error) =>
  createAction(TO_ACCEPT_ORDERS_LIST_ERROR, { error });

const toAcceptOrdersListsReset = () =>
  createAction(TO_ACCEPT_ORDERS_LIST_RESET);

const toRedeemOrdersLists = ({ status, page, pageSize, isBusiness }) =>
  createAction(TO_REDEEM_ORDERS_LIST, { status, page, pageSize, isBusiness });

const toRedeemOrdersListsSuccess = (data) =>
  createAction(TO_REDEEM_ORDERS_LIST_SUCCESS, { data });

const toRedeemOrdersListsError = (error) =>
  createAction(TO_REDEEM_ORDERS_LIST_ERROR, { error });

const toRedeemOrdersListsReset = () =>
  createAction(TO_REDEEM_ORDERS_LIST_RESET);

module.exports = {
  allOrdersLists,
  allOrdersListsSuccess,
  allOrdersListsError,
  allOrdersListsReset,

  toPayOrdersLists,
  toPayOrdersListsSuccess,
  toPayOrdersListsError,
  toPayOrdersListsReset,

  toPackOrdersLists,
  toPackOrdersListsSuccess,
  toPackOrdersListsError,
  toPackOrdersListsReset,

  toShipOrdersLists,
  toShipOrdersListsSuccess,
  toShipOrdersListsError,
  toShipOrdersListsReset,

  toRecieveOrdersLists,
  toRecieveOrdersListsSuccess,
  toRecieveOrdersListsError,
  toRecieveOrdersListsReset,

  toCompleteOrdersLists,
  toCompleteOrdersListsSuccess,
  toCompleteOrdersListsError,
  toCompleteOrdersListsReset,

  returnOrdersLists,
  returnOrdersListsSuccess,
  returnOrdersListsError,
  returnOrdersListsReset,

  cancel,
  cancelSuccess,
  cancelError,
  cancelReset,

  orderDetails,
  orderDetailsSuccess,
  orderDetailsError,
  orderDetailsReset,

  cancelledOrders,
  cancelledOrdersSuccess,
  cancelledOrdersError,
  cancelledOrdersReset,

  recievedOrders,
  recievedOrdersSuccess,
  recievedOrdersError,
  recievedOrdersReset,

  toAcceptOrdersLists,
  toAcceptOrdersListsSuccess,
  toAcceptOrdersListsError,
  toAcceptOrdersListsReset,

  toRedeemOrdersLists,
  toRedeemOrdersListsSuccess,
  toRedeemOrdersListsError,
  toRedeemOrdersListsReset,
};
